import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {PaymentMethodDetails, TOpenBankingPaymentMethodStore} from '@/pages/payment-methods'
import {PaymentMethodsOpenBankingStoreSymbol} from '@/pages/payment-methods/PaymentMethods/PaymentMethods'
import {PaymentMethodType} from '@/constants'
import {COMPANY_NAME} from '@/constants/app'
export const OpenBankingPaymentMethod = observer(() => {
    const { t } = useTranslation()
    const store = useInjection<TOpenBankingPaymentMethodStore>(PaymentMethodsOpenBankingStoreSymbol)

    return <PaymentMethodDetails
        title={t('OpenBankingPaymentMethod.title')}
        description={<Trans
            i18nKey='OpenBankingPaymentMethod.description'
            components={{ br: <br/> }}
            values={{companyName: COMPANY_NAME}}
        />}
        paymentMethodType={PaymentMethodType.openbanking}
        stores={store.stores}
    />
})
